import styled from "styled-components";

export const LoaderContainer = styled.div`
  height: 100%;
  width: 100%;
  display: block;  
`;